// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__1l5B7","imageUploader":"EGiftCard_imageUploader__2sKFn"};